



// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Filters
import formatPhone from '@/shared/filters/formatPhone.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';
import pluralizeFilter from '@/shared/filters/pluralize.filter.ts';
import round from '@/shared/filters/round.filter.ts';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';
import Endpoints from '@/constants/endpoints';
import RouteNames from '@/constants/route-names';

// Components
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import Tooltip, { TooltipColor, TooltipAlign } from '@/shared/components/Tooltip.component.vue';
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import Field from '@/shared/components/field.component.vue';
import SpotlightText, { SpotlightTextColor } from '@/shared/components/SpotlightText.component.vue';
import CheckIcon, { CheckIconColor } from '@/shared/components/CheckIcon.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import FloatMenu, {
    FloatMenuPosition,
} from '@/shared/components/float-menu.component.vue';
import MenuElement, {
    MenuElementBgColor,
    MenuElementBgColorHover,
    MenuElementSize,
} from '@/shared/components/menu-element.component.vue';
import ButtonSwitch, {
    SwitchActiveColor,
    ButtonSwitchPredefinedStyle,
} from "@/shared/components/button-switch.component.vue";
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';

// Views
import NoteItem from '@/manager/convocation/views/convocationDetail/noteItem/noteItem.view.vue';

// Models
import Bill, { TransactionType } from '@/manager/billing/models/bill.model';
import { PaymentMethod, PaymentMethodLiteral } from '@/clickbuy/purchase/models/purchase.model';
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';

// Mixins
import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';

// Services
import BillingService from '@/manager/billing/billing.service';


@Component({
    components: {
        Btn,
        ButtonSwitch,
        CheckIcon,
        Field,
        FloatMenu,
        Icon,
        MenuElement,
        Modal,
        NoteItem,
        Spinner,
        SpotlightText,
        SearchAutocomplete,
        TextArea,
        Tooltip,
    },
    methods: {
        ...mapActions({
            setCurrentBill: 'setCurrentBill',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            getBill: 'getBill',
            getBillList: 'getBillList',
            getBillNotes: 'getBillNotes',
            clientList: "getClientList"
        }),
    },
    filters: {
        formatDate,
        formatPhone,
        pluralizeFilter,
        round,
    },
})
export default class BillRow extends Mixins<WithSpinner>(WithSpinner) {
    @Prop() private rowNumber!: number;
    @Prop() private billId!: string;
    @Prop() private isClientList!: string;

    private assets = Assets;
    private openCollapsableInfo = false;
    private yetOpenedCollapsableInfo = false;
    private iconEnum = IconEnum;
    private tooltipColor = TooltipColor;
    private btnWidth = BtnWidth;
    private btnColor = BtnColor;
    private btnPredefinedClass = BtnPredefinedStyle;
    private modalTitleColor = ModalTitleColor;
    private menuElementSize = MenuElementSize;
    private menuElementBgColor = MenuElementBgColor;
    private menuElementBgColorHover = MenuElementBgColorHover;
    private floatMenuPosition = FloatMenuPosition;
    private setCurrentBill!: any;
    private getProfile!: any;
    private getBill!: any;
    private getBillList!: any;
    private getBillNotes!: any;
    private spotlightTextColor = SpotlightTextColor;
    private deleteBillModalOpened = false;
    private addObservationBillModalOpened = false;
    private generateBillRefundModalOpened = false;
    private cambioDatosModalOpened = false;
    private modalNoteEmpty = false;
    private modalNote = '';
    private noteType = 0; //nota:0, texto:1
    private fiscalData!: any;
    private fiscalDataExtensions!: any;
    private defaultFiscalData!: any;
    private fiscalDataObj = {
        'user': '',
        'email': '',
        'address': '',
        'postalCode': '',
        'state': '',
        'country': '',
        'town': '',
        'firstName': '',
        'lastName': '',
        'secondLastName': '',
        'nif': '',
        'phone': ' ',
        'id': '',
        "isDefault": false
    };
    private constants = Constants;
    private timeSwitchSelected = this.constants.switchGenerals;
    private refundedBillData: any;
    private BillhasRefundedBill = false;
    private refundedOriginBill: any;
    private refundedOriginBillExist = false;
    private disableBillRefund = false
    private colValue!: any;
    private searchClient: any = false;
    private mentions: any = [];
    private selectedClient!: any;
    private searchString = "";
    private searchTimeout: any = null

    @Watch("modalNote")
    private watchModalNote(newVal: any, oldVal: any) {
        if (newVal.slice(-1) == "$") {
            this.searchClient = true;
        } else {
            this.searchClient = false;
        }
    }

    @Watch("searchString")
    public watchsearchString(newVal: any, oldVal: any) {
        if (newVal && newVal.length > 3 && !this.selectedClient) {
            if (this.searchTimeout != null) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.searchCallback();
            }, 1000);
        }
    }

    public searchCallback() {
        if (this.searchString === "") {
            this.selectedClient = null;
        }
        this.fetchClientList();
    }

    private clearClient() {
        this.selectedClient = null;
    }

    private async selectClient(option: any) {
        this.selectedClient = option;
        this.searchClient = false;
        // console.log(this.selectedClient);
        this.modalNote += this.selectedClient.text;
        this.mentions.push(this.selectedClient)
    }

    private fetchClientList() {
        const payload = {
            limit: 20,
            search: this.searchString
        };
        this.$store.dispatch("fetchClientList", payload);
    }


    @Watch('paymentStatusSelected')
    private watchPaymentStatus(newVal: any, oldVal: any) {
        this.bill.paymentStatus = Number(newVal.value);
        this.patchBill({ payment_status: this.bill.paymentStatus });
    }

    private checkRefundedOriginBillExist(newVal: any) {
        if (newVal != null) {
            this.refundedOriginBillExist = true;
        } else {
            this.refundedOriginBillExist = false;
        }
    }

    private checkBillhasRefundedBill(newVal: any) {
        if (newVal != null) {
            this.BillhasRefundedBill = true;
        } else {
            this.BillhasRefundedBill = false;
        }
    }


    private created() {
        this.initializeComponent();
        // this.fetchRefundedOriginBill(this.bill.id)
        // this.fetchFiscalDataList()
        // if (this.bill.refundedBill) {
        //     this.fetchRefundedOriginBill(this.bill)
        //     this.fetchRefundedOriginBill(this.bill.refundedBill)
        // }

    }

    private mounted() {
        this.initializeDOMElementEvents();
        window.addEventListener('resize', this.handleResize);
    }

    private beforeDestroy() {
        // Remove the resize event listener when the component is destroyed
        window.removeEventListener('resize', this.handleResize);
    }

    private colspanValue() {
        // Dynamically determine colspan based on the display width
        this.colValue = this.$el.clientWidth <= 1500 ? 12 : 6;
    }

    private handleResize() {
        this.colspanValue()
        this.$forceUpdate(); // Force update to recalculate colspan on resize
    }


    get bill() {
        return this.getBill(this.billId);
    }

    get oddRow() {
        return (this.rowNumber % 2 !== 0);
    }

    get billUrl() {
        return this.bill.document;
    }

    get billProducts() {
        let text = 'Sin producto asociado';
        if (this.bill.billLine.length > 0) {
            text = this.bill.billLine[0].productName;
            const lines = this.bill.billLine.length;
            if (lines > 1) {
                text = `${lines} productos`;
            }
        }
        return text;
    }

    get billIsEmitted() {
        return (this.bill.transactionType === TransactionType.TransactionEmitted);
    }

    get billIsReceived() {
        return (this.bill.transactionType === TransactionType.TransactionReceived);
    }

    get billIsEnabled() {
        var date = new Date(this.bill.date)
        return (date.getFullYear() >= new Date().getFullYear() && this.bill.communicationStatus == 0 || this.bill.hasRestrictions == false);
    }

    get notes() {
        return this.getBillNotes(this.billId)//.sort(function(a:any, b:any){ return (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0); });
    }

    // get hasNotes(){
    //     let notes = this.getBillNotes(this.billId).sort(function(a:any, b:any){ return (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0); })
    //     if (notes.length > 0) {
    //         return notes[0].type == 0;
    //     }
    // }

    // get hasTextNotes(){
    //     let notes = this.getBillNotes(this.billId).sort(function(a:any, b:any){ return (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0); })
    //     if (notes.length > 0) {
    //         return notes[0].type == 1;
    //     }
    // }

    get showNoteRow() {
        return this.openCollapsableInfo && !this.spinner.show;
    }

    get showSpinnerNoteRow() {
        return this.openCollapsableInfo && this.spinner.show;
    }

    get showBillRow() {
        return this.openCollapsableInfo && !this.spinner2.show;
    }

    get showSpinnerBillRow() {
        return this.openCollapsableInfo && this.spinner2.show;
    }

    get noteListTransitionName() {
        let transitionName = 'note-list';
        if (!this.yetOpenedCollapsableInfo) {
            transitionName += '-disabled';
        }
        return transitionName;
    }

    get modalNotePlaceholder() {
        let placeholder = ''
        if (this.noteType == 0) {
            placeholder = 'Comparte alguna nota con tus compañeros sobre esta factura...';
        } else {
            placeholder = 'Comparte algun texto con tus compañeros sobre esta factura...';
        }
        if (this.modalNoteEmpty) {
            placeholder = 'Este campo no puede estar vacío...';
        }
        return placeholder;
    }

    get clientOrProvider() {
        let instance = null;
        const object = {
            name: '',
            phone: '',
            email: '',
            nif: '',
            address: '',
            icon: '',
        };
        if (this.billIsReceived) {
            instance = this.bill.provider;
            if (instance) {
                object.name = instance.name;
                object.phone = instance.phone;
                object.email = instance.email;
                object.nif = instance.cif;
                object.address = instance.address;
                object.icon = IconEnum.Provider;
            }

        } else if (this.billIsEmitted) {
            if (this.bill.client && this.bill.client.user) {
                object.name = this.bill.client.user.fullName;
                if (this.bill.client.user.profile) {
                    object.phone = this.bill.client.user.profile.phone;
                    object.email = this.bill.client.user.email;
                    object.address = this.bill.client.user.profile.address;
                    object.nif = this.bill.client.user.profile.nif;
                }

            }
            object.icon = IconEnum.Participant;
            // object.phone = this.bill.phone;
            // object.email = this.bill.email;
            // // object.address = this.bill.client.user.profile.address;
            // object.address = this.bill.address;
            // object.nif = this.bill.nif;
        }
        return object;
    }

    get arrowIconProperties() {
        const arrow = {
            icon: this.iconEnum.CompleteArrowDown,
            color: 'color-blue-dark',
            classes: '',
            tooltip: {
                color: TooltipColor.BlueDark,
                text: 'Recibida',
            },
        };
        if (this.billIsEmitted) {
            arrow.color = 'color-primary';
            arrow.classes = 'rotate-180-right';
            arrow.tooltip = {
                color: TooltipColor.Primary,
                text: 'Emitida',
            };
        }
        return arrow;
    }

    get observationsTooltip() {
        const numberOfNotes = this.bill.numberOfNotes;
        const pluralize = (this.$options as any).filters.pluralizeFilter(numberOfNotes, 'observación', 'observaciones');
        return `${numberOfNotes} ${pluralize}`;
    }

    get paymentMethod() {
        const paymentMethod = {
            icon: IconEnum.MenuSync,
            tooltipText: PaymentMethodLiteral[this.bill.paymentMethod],
        };
        if (this.bill.paymentMethod === PaymentMethod.Card) {
            paymentMethod.icon = IconEnum.CreditCard;
        } else if (this.bill.paymentMethod === PaymentMethod.DirectDebit) {
            paymentMethod.icon = IconEnum.Bank;
        } else if (this.bill.paymentMethod === PaymentMethod.Bizum) {
            paymentMethod.icon = IconEnum.Phone;
        }
        return paymentMethod;
    }

    get showGenerateButton() {
        return (
            (this.bill.refundedBill === null || this.bill.refundedBill == "") &&
            this.billIsEmitted
        );
    }

    get clientProfile() {
        if (this.bill.client && this.bill.client.user && this.bill.client.user.id) {
            const route = {
                name: RouteNames.ClientEdit,
                params: {
                    id: this.bill.client.user.id,
                },
            };
            return route;
        }
    }

    get timeFilter(): any[] {
        return [
            this.constants.switchGenerals,
            this.constants.switchConvocations,
            this.constants.switchPurchases,
            this.constants.switchBudgets,
            this.constants.switchBills,
            this.constants.switchFiscalDataExtension,
            this.constants.switchPaymentMethods,
        ];
    }

    get billBackUrl() {
        const url = window.location.origin + "/api/admin/bill/bill/" + this.bill.id + "/change"
        return url
    }

    get routerLinkToPurchase() {
        let route: any
        if (this.bill.purchase) {
            route = {
                name: RouteNames.PurchaseConvocationDetail,
                params: {
                    id: this.bill.purchase.convocationOrigin,
                },
                query: {
                    "search-string": this.bill.purchase.publicId,
                },
            };
        }
        return route;
    }

    get routerLinkToRefundedOriginBill() {
        let route: any
        if (this.bill.originBill) {
            route = {
                name: RouteNames.BillList,
                params: {
                    id: this.bill.originBill.id,
                },
                query: {
                    "search-string": this.bill.originBill.displayId,
                },
            };
        }
        return route;
    }

    get routerLinkToRefundedBill() {
        let route: any
        if (this.bill.refundedBill) {
            route = {
                name: RouteNames.BillList,
                params: {
                    id: this.bill.refundedBill.id,
                },
                query: {
                    "search-string": this.bill.refundedBill.displayId,
                },
            };
        }
        return route;
    }

    get purchaseBackUrl() {
        let url: any
        if (this.bill.purchase) {
            url = window.location.origin + "/api/admin/purchase/purchase/" + this.bill.purchase.id + "/change"
        }
        return url
    }

    // get BillhasRefundedBill(){
    //     let res = this.getBillList.find((objeto: { refundedBill: any; }) => objeto.refundedBill === this.bill.id);
    //     return res
    // }

    get purchase_discount() {
        let discount = 0;
        if (this.bill.purchase) {
            if (this.bill.purchase.trace != "False") {
                const regex = /Dto\. Pronto Pago: (\d+)/;
                const match = this.bill.purchase.note.match(regex);
                if (match) {
                    return match[1];
                } else {
                    return 0;
                }
            } else if (this.bill.purchase.soonPaymentPurchaseCheck) {
                discount = this.bill.purchase.soonPaymentDiscount;
            }
        }
        return discount;
    }

    private purchaseLineBackUrl(purchaseLine: any) {
        const url = window.location.origin + "/api/admin/purchase/purchaseline/" + purchaseLine.id + "/change"
        return url
    }

    private initializeComponent() {
        this.spinner.minimumTimeToShow = 500;
        this.spinner2.minimumTimeToShow = 500;
    }

    private onUploadBillDocumentSucess() {
        this.refetchBill();
        this.emitShowMessage('Documento actualizado correctamente', false);
    }

    private onUploadBillDocumentError(err: any) {
        this.emitShowMessage(Constants.internalServerErrorMessage, true);
    }

    private initializeDOMElementEvents() {
        if (this.billIsReceived) {
            const inputFile = (this.$refs.fileToUpload as HTMLInputElement);
            inputFile.addEventListener('change', (event: Event) => {
                const file = (inputFile as any).files[0];
                BillingService.uploadBillDocument({ id: this.billId, file })
                    .then(this.onUploadBillDocumentSucess, this.onUploadBillDocumentError);
            });
        }
    }

    private emitShowMessage(message: string, error: boolean = false) {
        this.$emit('show-message', { message, error });
    }

    private emitMessageError(response: any) {
        if (response.data && response.data.detail) {
            this.emitShowMessage(response.data.detail, true);
        }
    }

    private toggleCollapsableInfo() {
        this.handleResize()
        this.openCollapsableInfo = !this.openCollapsableInfo;
        if (this.openCollapsableInfo) {
            Vue.nextTick(() => {
                this.fetchBillNotes();
            });
        }
    }

    private toggleBillObservationModalOpened(value: boolean) {
        this.addObservationBillModalOpened = value;
        if (!value) {
            setTimeout(() => {
                this.mentions = [];
            }, 500);
            this.searchClient = false;
        }
    }

    private generateBillRefundModal(value: boolean) {
        this.generateBillRefundModalOpened = value;
    }

    private cambioDatosModal(value: boolean) {
        this.cambioDatosModalOpened = value;
    }

    private setNoteYype(value: number) {
        this.noteType = value;
    }

    private isLastBillLine(index: number) {
        const lines = this.bill.billLine.length - 1;
        return index === lines;
    }

    private fetchBillNotes() {
        this.requestShowSpinner();
        this.$store.dispatch('fetchBillNotes', { id: this.billId })
            .then(
                (res) => {
                    this.changeSpinnerVisibility(false);
                    if (!this.yetOpenedCollapsableInfo) {
                        this.yetOpenedCollapsableInfo = true;
                    }
                },
            );
    }

    private addNote() {
        if (this.modalNote.length === 0) {
            this.modalNoteEmpty = true;
        } else {
            this.addObservationBillModalOpened = false;
            this.requestShowSpinner();
            this.$store.dispatch('newBillNote', {
                billId: this.billId,
                employee: { user: { id: this.getProfile.id } },
                note: this.modalNote,
                type: this.noteType,
                mentions: this.mentions,
            }).then(
                (res) => {
                    this.refreshNotes();
                    this.mentions = [];
                    this.searchString =""
                    this.searchClient = false
                    this.clearClient()
                    this.resetModalNoteEmpty(true);
                    this.fetchBillNotes();
                    this.changeSpinnerVisibility(false);
                    this.refetchBill();
                },
            );
        }

    }

    private refreshNotes() {
        this.requestShowSpinner();
        this.resetModalNoteEmpty(true);
        this.fetchBillNotes();
        this.changeSpinnerVisibility(false);
        this.refetchBill();
    }

    private updateNote(noteId: string, noteContent: string, isPostponement?: string, mentions?: any[]) {
        const payload = {
            billId: this.billId,
            noteId,
            data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement, mentions: mentions },
        };
        this.$store.dispatch('patchBillNote', payload).then((res: any) => {
            this.refreshNotes();
            this.mentions = [];
            this.searchString =""
            this.searchClient = false
            this.clearClient()
        });
    }

    private refetchBill() {
        this.$store.dispatch('fetchBill', { id: this.billId });
    }

    /**
     * Get fiscal data from client related in bill
     */
    private fetchFiscalDataList() {
        this.requestShowSpinner2();
        this.changeSpinnerVisibility2(true);
        if (this.bill.client && this.bill.client.user && this.bill.client.user.id) {
            this.$store.dispatch('fiscalDataList', this.bill.client.user.id).then(
                res => {
                    this.checkFiscalDataDefault(res)
                    this.changeSpinnerVisibility2(false);
                }
            );
        }
    }

    private checkFiscalDataDefault(res: any) {
        let defaultFiscalDataList = res.fiscalDataExtensions.filter((item: any) => item.id == this.bill.fiscalDataExtension);

        this.fiscalData = res.fiscalData == this.bill.fiscalData ? res.fiscalData : null
        this.fiscalDataExtensions = res.fiscalDataExtensions

        if (defaultFiscalDataList.length == 0) {
            this.defaultFiscalData = this.fiscalData
        }
        else {
            this.defaultFiscalData = defaultFiscalDataList[0]
        }
    }

    private deleteNote(noteId: string) {
        const payload = {
            id: this.billId,
            noteId,
        };
        this.$store.dispatch('removeBillNote', payload)
            .then((res: any) => {
                this.refetchBill();
            });
    }

    private resetModalNoteEmpty(force: boolean) {
        if (force || this.modalNote === '') {
            this.modalNoteEmpty = false;
            this.modalNote = '';
        }
    }

    private editBill() {
        const billToEdit = Object.assign({}, this.bill);
        billToEdit.billLine = Object.assign([], this.bill.billLine);
        this.setCurrentBill(billToEdit);
        this.$emit('edit-bill');
    }

    private modifyDataPrivate() {
        this.cambioDatosModal(false)
        this.$emit('modify-data');
        this.editBill();
    }

    private generateUrlChangeData() {
        var changeDataUrl = (window.location.href.split('#')[0] + '#/public/billing/' + this.bill.id);
        this.cambioDatosModal(false);
        const navigatorAny:any = navigator
        navigatorAny.clipboard.writeText(changeDataUrl)
            .then(() => {
                this.emitShowMessage('Enlace copiado al portapapeles');
            })
            .catch((err:any) => {
                console.error('Error al copiar el enlace:', err);
            });
    }


    private refetchList() {
        this.$emit('refetch-list');
    }

    private searchBill(billDisplayId: string) {
        this.$emit('search-bill', billDisplayId);
    }

    private patchBill(data: any) {
        const payload = {
            id: this.billId,
            data,
        };
        this.$store.dispatch('patchBill', payload);
    }

    private onSucess() {
        this.emitShowMessage('Email envíado correctamente');
    }

    private onRefundSucess() {
        this.refetchList();
        this.disableBillRefund = false
    }

    private onRefundError(err: any) {
        let error = '';
        const response = err.response;
        if (response) {
            if (response.status === 409) {
                error = 'El abono para esta factura ya se ha generado';
            } else {
                error = Constants.internalServerErrorMessage;
            }
        }
        this.emitShowMessage(error, true);
    }

    private onError() {
        this.emitShowMessage(Constants.internalServerErrorMessage, true);
    }

    private billRefund() {
        this.disableBillRefund = true
        BillingService.refundBill(this.billId, this.bill)
            .then(this.onRefundSucess, this.onRefundError);
        this.$store.dispatch('refundBill', { id: this.billId });
    }

    private sendDocumentEmail() {
        BillingService.sendBillEmail(this.billId)
            .then(this.onSucess, this.onError);
    }

    private uploadDocument() {
        (this.$refs.fileToUpload as HTMLInputElement).click();
    }

    private iconDocumentAction() {
        if (this.billIsReceived && !this.billUrl) {
            this.uploadDocument();
        } else {
            this.seeDocument();
        }
    }

    private seeDocument() {
        window.open(this.billUrl, '_blank');
    }

    private timeFilterChanged(option: any) {
        const urlParams = new URLSearchParams();
        urlParams.append('search', option.requestName); // Añade el parámetro adicional
        const url = `${this.$router.resolve(this.clientProfile as any).href}?${urlParams.toString()}`;
        window.open(url, "_blank")
    }

}

